module.exports = __webpack_public_path__ + "img/HeroTypesQuiz_CosmicGuardian.e369bac3.png";